import PageToolbar from '@/components/linear/page-toolbar';
import { companyPath } from '@/lib/linear-paths';
import CompanyForm from '@/pages/companies/components/company-form';
import type { Company } from '@/types/company';

interface Props {
  company: Company;
}

export default function Edit({ company }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title={`Edit ${company.name}`} showNew={false} />
      <div className="ln-page-scroll">
        <div className="ln-form-page">
          <h1>Edit {company.name}</h1>
          <p className="ln-lede">Update workspace details and GitHub watch settings.</p>
          <CompanyForm
            company={company}
            action={companyPath(company.id)}
            method="patch"
            submitLabel="Save changes"
          />
        </div>
      </div>
    </div>
  );
}
